import type { Locale } from "./locales";

// Tool NAMES only (not descriptions or instructions -- that heavier
// content stays English for now, a deliberate scope line, not an
// oversight). Keyed by tool id, same fallback pattern as
// category-persona-translations.ts: a locale or id not found here
// falls back to the original English name from tools-data.ts, so a gap
// degrades to correct English rather than breaking.

export const TOOL_NAME_TRANSLATIONS: Partial<Record<Locale, Record<string, string>>> = {
  es: {
    "merge-pdf": "Fusionar PDF",
    "split-pdf": "Dividir PDF",
    "compress-pdf": "Comprimir PDF",
    "rotate-pdf": "Rotar PDF",
    "pdf-to-word": "PDF a Word",
    "pdf-to-jpg": "PDF a JPG",
    "pdf-to-excel": "PDF a Excel",
    "word-to-pdf": "Word a PDF",
    "excel-to-pdf": "Excel a PDF",
    "powerpoint-to-pdf": "PowerPoint a PDF",
    "image-to-pdf": "Imagen a PDF",
    "pdf-password": "Añadir Contraseña a PDF",
    "pdf-watermark": "Añadir Marca de Agua",
    "extract-pdf": "Extraer Páginas y Texto",
    "organize-pdf": "Organizar PDF",
    "add-page-numbers": "Añadir Números de Página",
    "book-writing-toolbox": "Creador de Libros",
    "magazine-maker": "Creador de Revistas",
    "catalog-maker": "Creador de Catálogos",
    "document-assembler": "Ensamblador de Documentos",
    "redact-pdf": "Redactar PDF",
    "ocr-pdf": "OCR de PDF",
    "html-to-pdf": "HTML a PDF",
    "fillable-forms": "Formularios Rellenables",
    "compare-pdf": "Comparar PDF",
    "repair-pdf": "Reparar PDF",
    "crop-pdf": "Recortar PDF",
    "pdf-editor": "Editor de PDF",
    "sign-pdf": "Firmar PDF",
    "compress-image": "Comprimir Imagen",
    "resize-crop": "Redimensionar y Recortar",
    "convert-image": "Convertir Formatos",
    "remove-background": "Eliminar Fondo",
    "flip-rotate-image": "Voltear y Rotar",
    "image-filters": "Añadir Filtros y Efectos",
    "document-scanner": "Escáner de Documentos",
    "camera-capture": "Captura de Cámara",
    "bulk-image": "Procesador Masivo",
    "webp-converter": "Convertidor WebP",
    "passport-photo": "Creador de Foto de Pasaporte",
    "screenshot-tool": "Herramienta de Captura",
    "collage-maker": "Creador de Collages",
    "compress-video": "Comprimir Video",
    "convert-video": "Convertidor de Formato",
    "trim-video": "Recortar y Cortar",
    "merge-video": "Fusionar Videos",
    "video-to-gif": "Video a GIF",
    "thumbnail-gen": "Generador de Miniaturas",
    "subtitle-adder": "Añadir Subtítulos",
    "screen-recorder": "Grabador de Pantalla",
    "extract-audio": "Extraer Audio",
    "audio-trimmer": "Recortar Audio",
    "audio-converter": "Convertidor de Audio",
    "audio-merger": "Fusionar Audio",
    "audio-compressor": "Compresor de Audio",
    "voice-recorder": "Grabador de Voz",
    "audio-speed-changer": "Cambiar Velocidad de Audio",
    "silence-remover": "Eliminar Silencios",
    "audio-normalizer": "Normalizador de Volumen",
    "audio-comparer": "Comparar Dos Audios",
    "noise-remover": "Eliminar Ruido de Fondo",
    "audio-scrambler": "Codificador de Audio",
  },
  pt: {
    "merge-pdf": "Mesclar PDF",
    "split-pdf": "Dividir PDF",
    "compress-pdf": "Comprimir PDF",
    "rotate-pdf": "Girar PDF",
    "pdf-to-word": "PDF para Word",
    "pdf-to-jpg": "PDF para JPG",
    "pdf-to-excel": "PDF para Excel",
    "word-to-pdf": "Word para PDF",
    "excel-to-pdf": "Excel para PDF",
    "powerpoint-to-pdf": "PowerPoint para PDF",
    "image-to-pdf": "Imagem para PDF",
    "pdf-password": "Adicionar Senha ao PDF",
    "pdf-watermark": "Adicionar Marca d'Água",
    "extract-pdf": "Extrair Páginas e Texto",
    "organize-pdf": "Organizar PDF",
    "add-page-numbers": "Adicionar Números de Página",
    "book-writing-toolbox": "Criador de Livros",
    "magazine-maker": "Criador de Revistas",
    "catalog-maker": "Criador de Catálogos",
    "document-assembler": "Montador de Documentos",
    "redact-pdf": "Redigir PDF",
    "ocr-pdf": "OCR de PDF",
    "html-to-pdf": "HTML para PDF",
    "fillable-forms": "Formulários Preenchíveis",
    "compare-pdf": "Comparar PDF",
    "repair-pdf": "Reparar PDF",
    "crop-pdf": "Cortar PDF",
    "pdf-editor": "Editor de PDF",
    "sign-pdf": "Assinar PDF",
    "compress-image": "Comprimir Imagem",
    "resize-crop": "Redimensionar e Cortar",
    "convert-image": "Converter Formatos",
    "remove-background": "Remover Fundo",
    "flip-rotate-image": "Espelhar e Girar",
    "image-filters": "Adicionar Filtros e Efeitos",
    "document-scanner": "Scanner de Documentos",
    "camera-capture": "Captura pela Câmera",
    "bulk-image": "Processador em Lote",
    "webp-converter": "Conversor WebP",
    "passport-photo": "Criador de Foto para Passaporte",
    "screenshot-tool": "Ferramenta de Captura de Tela",
    "collage-maker": "Criador de Colagens",
    "compress-video": "Comprimir Vídeo",
    "convert-video": "Conversor de Formato",
    "trim-video": "Cortar e Aparar",
    "merge-video": "Mesclar Vídeos",
    "video-to-gif": "Vídeo para GIF",
    "thumbnail-gen": "Gerador de Miniaturas",
    "subtitle-adder": "Adicionar Legendas",
    "screen-recorder": "Gravador de Tela",
    "extract-audio": "Extrair Áudio",
    "audio-trimmer": "Cortar Áudio",
    "audio-converter": "Conversor de Áudio",
    "audio-merger": "Mesclar Áudio",
    "audio-compressor": "Compressor de Áudio",
    "voice-recorder": "Gravador de Voz",
    "audio-speed-changer": "Alterar Velocidade do Áudio",
    "silence-remover": "Remover Silêncios",
    "audio-normalizer": "Normalizador de Volume",
    "audio-comparer": "Comparar Dois Áudios",
    "noise-remover": "Remover Ruído de Fundo",
    "audio-scrambler": "Codificador de Áudio",
  },
  fr: {
    "merge-pdf": "Fusionner PDF",
    "split-pdf": "Diviser PDF",
    "compress-pdf": "Compresser PDF",
    "rotate-pdf": "Faire Pivoter PDF",
    "pdf-to-word": "PDF vers Word",
    "pdf-to-jpg": "PDF vers JPG",
    "pdf-to-excel": "PDF vers Excel",
    "word-to-pdf": "Word vers PDF",
    "excel-to-pdf": "Excel vers PDF",
    "powerpoint-to-pdf": "PowerPoint vers PDF",
    "image-to-pdf": "Image vers PDF",
    "pdf-password": "Ajouter un Mot de Passe PDF",
    "pdf-watermark": "Ajouter un Filigrane",
    "extract-pdf": "Extraire Pages et Texte",
    "organize-pdf": "Organiser PDF",
    "add-page-numbers": "Ajouter des Numéros de Page",
    "book-writing-toolbox": "Créateur de Livres",
    "magazine-maker": "Créateur de Magazines",
    "catalog-maker": "Créateur de Catalogues",
    "document-assembler": "Assembleur de Documents",
    "redact-pdf": "Caviarder PDF",
    "ocr-pdf": "OCR PDF",
    "html-to-pdf": "HTML vers PDF",
    "fillable-forms": "Formulaires à Remplir",
    "compare-pdf": "Comparer PDF",
    "repair-pdf": "Réparer PDF",
    "crop-pdf": "Recadrer PDF",
    "pdf-editor": "Éditeur PDF",
    "sign-pdf": "Signer PDF",
    "compress-image": "Compresser Image",
    "resize-crop": "Redimensionner et Recadrer",
    "convert-image": "Convertir les Formats",
    "remove-background": "Supprimer l'Arrière-plan",
    "flip-rotate-image": "Retourner et Pivoter",
    "image-filters": "Ajouter Filtres et Effets",
    "document-scanner": "Scanner de Documents",
    "camera-capture": "Capture par Caméra",
    "bulk-image": "Traitement par Lots",
    "webp-converter": "Convertisseur WebP",
    "passport-photo": "Créateur de Photo d'Identité",
    "screenshot-tool": "Outil de Capture d'Écran",
    "collage-maker": "Créateur de Collages",
    "compress-video": "Compresser Vidéo",
    "convert-video": "Convertisseur de Format",
    "trim-video": "Découper et Rogner",
    "merge-video": "Fusionner des Vidéos",
    "video-to-gif": "Vidéo vers GIF",
    "thumbnail-gen": "Générateur de Miniatures",
    "subtitle-adder": "Ajouter des Sous-titres",
    "screen-recorder": "Enregistreur d'Écran",
    "extract-audio": "Extraire l'Audio",
    "audio-trimmer": "Découper l'Audio",
    "audio-converter": "Convertisseur Audio",
    "audio-merger": "Fusionner Audio",
    "audio-compressor": "Compresseur Audio",
    "voice-recorder": "Enregistreur Vocal",
    "audio-speed-changer": "Changer la Vitesse Audio",
    "silence-remover": "Supprimer les Silences",
    "audio-normalizer": "Normalisateur de Volume",
    "audio-comparer": "Comparer Deux Fichiers Audio",
    "noise-remover": "Supprimer le Bruit de Fond",
    "audio-scrambler": "Brouilleur Audio",
  },
  de: {
    "merge-pdf": "PDF Zusammenführen",
    "split-pdf": "PDF Teilen",
    "compress-pdf": "PDF Komprimieren",
    "rotate-pdf": "PDF Drehen",
    "pdf-to-word": "PDF zu Word",
    "pdf-to-jpg": "PDF zu JPG",
    "pdf-to-excel": "PDF zu Excel",
    "word-to-pdf": "Word zu PDF",
    "excel-to-pdf": "Excel zu PDF",
    "powerpoint-to-pdf": "PowerPoint zu PDF",
    "image-to-pdf": "Bild zu PDF",
    "pdf-password": "PDF-Passwort Hinzufügen",
    "pdf-watermark": "Wasserzeichen Hinzufügen",
    "extract-pdf": "Seiten und Text Extrahieren",
    "organize-pdf": "PDF Organisieren",
    "add-page-numbers": "Seitenzahlen Hinzufügen",
    "book-writing-toolbox": "Buch-Ersteller",
    "magazine-maker": "Magazin-Ersteller",
    "catalog-maker": "Katalog-Ersteller",
    "document-assembler": "Dokumenten-Zusammensteller",
    "redact-pdf": "PDF Schwärzen",
    "ocr-pdf": "PDF OCR",
    "html-to-pdf": "HTML zu PDF",
    "fillable-forms": "Ausfüllbare Formulare",
    "compare-pdf": "PDF Vergleichen",
    "repair-pdf": "PDF Reparieren",
    "crop-pdf": "PDF Zuschneiden",
    "pdf-editor": "PDF-Editor",
    "sign-pdf": "PDF Unterschreiben",
    "compress-image": "Bild Komprimieren",
    "resize-crop": "Größe Ändern und Zuschneiden",
    "convert-image": "Formate Konvertieren",
    "remove-background": "Hintergrund Entfernen",
    "flip-rotate-image": "Spiegeln und Drehen",
    "image-filters": "Filter und Effekte Hinzufügen",
    "document-scanner": "Dokumentenscanner",
    "camera-capture": "Kamera-Aufnahme",
    "bulk-image": "Stapelverarbeitung",
    "webp-converter": "WebP-Konverter",
    "passport-photo": "Passfoto-Ersteller",
    "screenshot-tool": "Screenshot-Tool",
    "collage-maker": "Collagen-Ersteller",
    "compress-video": "Video Komprimieren",
    "convert-video": "Format-Konverter",
    "trim-video": "Schneiden und Kürzen",
    "merge-video": "Videos Zusammenführen",
    "video-to-gif": "Video zu GIF",
    "thumbnail-gen": "Thumbnail-Generator",
    "subtitle-adder": "Untertitel Hinzufügen",
    "screen-recorder": "Bildschirmrekorder",
    "extract-audio": "Audio Extrahieren",
    "audio-trimmer": "Audio Schneiden",
    "audio-converter": "Audio-Konverter",
    "audio-merger": "Audio Zusammenführen",
    "audio-compressor": "Audio-Kompressor",
    "voice-recorder": "Sprachrekorder",
    "audio-speed-changer": "Audio-Geschwindigkeit Ändern",
    "silence-remover": "Stille Entfernen",
    "audio-normalizer": "Lautstärke-Normalisierer",
    "audio-comparer": "Zwei Audiodateien Vergleichen",
    "noise-remover": "Hintergrundgeräusche Entfernen",
    "audio-scrambler": "Audio-Verschlüsseler",
  },
  ja: {
    "merge-pdf": "PDF結合",
    "split-pdf": "PDF分割",
    "compress-pdf": "PDF圧縮",
    "rotate-pdf": "PDF回転",
    "pdf-to-word": "PDFをWordに変換",
    "pdf-to-jpg": "PDFをJPGに変換",
    "pdf-to-excel": "PDFをExcelに変換",
    "word-to-pdf": "WordをPDFに変換",
    "excel-to-pdf": "ExcelをPDFに変換",
    "powerpoint-to-pdf": "PowerPointをPDFに変換",
    "image-to-pdf": "画像をPDFに変換",
    "pdf-password": "PDFパスワード追加",
    "pdf-watermark": "透かし追加",
    "extract-pdf": "ページ・テキスト抽出",
    "organize-pdf": "PDF整理",
    "add-page-numbers": "ページ番号追加",
    "book-writing-toolbox": "書籍作成ツール",
    "magazine-maker": "雑誌作成ツール",
    "catalog-maker": "カタログ作成ツール",
    "document-assembler": "文書組み立てツール",
    "redact-pdf": "PDF情報削除",
    "ocr-pdf": "PDF OCR",
    "html-to-pdf": "HTMLをPDFに変換",
    "fillable-forms": "入力可能フォーム",
    "compare-pdf": "PDF比較",
    "repair-pdf": "PDF修復",
    "crop-pdf": "PDFトリミング",
    "pdf-editor": "PDFエディター",
    "sign-pdf": "PDF署名",
    "compress-image": "画像圧縮",
    "resize-crop": "リサイズ・トリミング",
    "convert-image": "形式変換",
    "remove-background": "背景除去",
    "flip-rotate-image": "反転・回転",
    "image-filters": "フィルター・エフェクト追加",
    "document-scanner": "書類スキャナー",
    "camera-capture": "カメラ撮影",
    "bulk-image": "一括処理",
    "webp-converter": "WebP変換",
    "passport-photo": "証明写真作成",
    "screenshot-tool": "スクリーンショットツール",
    "collage-maker": "コラージュ作成",
    "compress-video": "動画圧縮",
    "convert-video": "形式変換",
    "trim-video": "トリミング・カット",
    "merge-video": "動画結合",
    "video-to-gif": "動画をGIFに変換",
    "thumbnail-gen": "サムネイル生成",
    "subtitle-adder": "字幕追加",
    "screen-recorder": "画面録画",
    "extract-audio": "音声抽出",
    "audio-trimmer": "音声トリミング",
    "audio-converter": "音声変換",
    "audio-merger": "音声結合",
    "audio-compressor": "音声圧縮",
    "voice-recorder": "ボイスレコーダー",
    "audio-speed-changer": "音声速度変更",
    "silence-remover": "無音除去",
    "audio-normalizer": "音量正規化",
    "audio-comparer": "音声ファイル比較",
    "noise-remover": "背景ノイズ除去",
    "audio-scrambler": "音声スクランブラー",
  },
  hi: {
    "merge-pdf": "PDF मर्ज करें",
    "split-pdf": "PDF स्प्लिट करें",
    "compress-pdf": "PDF कंप्रेस करें",
    "rotate-pdf": "PDF रोटेट करें",
    "pdf-to-word": "PDF से Word",
    "pdf-to-jpg": "PDF से JPG",
    "pdf-to-excel": "PDF से Excel",
    "word-to-pdf": "Word से PDF",
    "excel-to-pdf": "Excel से PDF",
    "powerpoint-to-pdf": "PowerPoint से PDF",
    "image-to-pdf": "इमेज से PDF",
    "pdf-password": "PDF पासवर्ड जोड़ें",
    "pdf-watermark": "वॉटरमार्क जोड़ें",
    "extract-pdf": "पेज और टेक्स्ट एक्सट्रैक्ट करें",
    "organize-pdf": "PDF व्यवस्थित करें",
    "add-page-numbers": "पेज नंबर जोड़ें",
    "book-writing-toolbox": "बुक मेकर",
    "magazine-maker": "मैगज़ीन मेकर",
    "catalog-maker": "कैटलॉग मेकर",
    "document-assembler": "डॉक्यूमेंट असेंबलर",
    "redact-pdf": "PDF रिडैक्ट करें",
    "ocr-pdf": "PDF OCR",
    "html-to-pdf": "HTML से PDF",
    "fillable-forms": "फिल करने योग्य फॉर्म",
    "compare-pdf": "PDF कंपेयर करें",
    "repair-pdf": "PDF रिपेयर करें",
    "crop-pdf": "PDF क्रॉप करें",
    "pdf-editor": "PDF एडिटर",
    "sign-pdf": "PDF साइन करें",
    "compress-image": "इमेज कंप्रेस करें",
    "resize-crop": "रीसाइज़ और क्रॉप",
    "convert-image": "फॉर्मेट कन्वर्ट करें",
    "remove-background": "बैकग्राउंड हटाएं",
    "flip-rotate-image": "फ्लिप और रोटेट",
    "image-filters": "फ़िल्टर और इफेक्ट्स जोड़ें",
    "document-scanner": "डॉक्यूमेंट स्कैनर",
    "camera-capture": "कैमरा कैप्चर",
    "bulk-image": "बल्क प्रोसेसर",
    "webp-converter": "WebP कन्वर्टर",
    "passport-photo": "पासपोर्ट फोटो मेकर",
    "screenshot-tool": "स्क्रीनशॉट टूल",
    "collage-maker": "फोटो कोलाज मेकर",
    "compress-video": "वीडियो कंप्रेस करें",
    "convert-video": "फॉर्मेट कन्वर्टर",
    "trim-video": "ट्रिम और कट",
    "merge-video": "वीडियो मर्ज करें",
    "video-to-gif": "वीडियो से GIF",
    "thumbnail-gen": "थंबनेल जनरेटर",
    "subtitle-adder": "सबटाइटल जोड़ें",
    "screen-recorder": "स्क्रीन रिकॉर्डर",
    "extract-audio": "ऑडियो एक्सट्रैक्ट करें",
    "audio-trimmer": "ऑडियो ट्रिमर",
    "audio-converter": "ऑडियो कन्वर्टर",
    "audio-merger": "ऑडियो मर्ज करें",
    "audio-compressor": "ऑडियो कंप्रेसर",
    "voice-recorder": "वॉइस रिकॉर्डर",
    "audio-speed-changer": "ऑडियो स्पीड बदलें",
    "silence-remover": "साइलेंस रिमूवर",
    "audio-normalizer": "वॉल्यूम नॉर्मलाइज़र",
    "audio-comparer": "दो ऑडियो फ़ाइलें कंपेयर करें",
    "noise-remover": "बैकग्राउंड नॉइज़ रिमूवर",
    "audio-scrambler": "ऑडियो स्क्रैम्बलर",
  },
  zh: {
    "merge-pdf": "合并PDF",
    "split-pdf": "拆分PDF",
    "compress-pdf": "压缩PDF",
    "rotate-pdf": "旋转PDF",
    "pdf-to-word": "PDF转Word",
    "pdf-to-jpg": "PDF转JPG",
    "pdf-to-excel": "PDF转Excel",
    "word-to-pdf": "Word转PDF",
    "excel-to-pdf": "Excel转PDF",
    "powerpoint-to-pdf": "PowerPoint转PDF",
    "image-to-pdf": "图片转PDF",
    "pdf-password": "添加PDF密码",
    "pdf-watermark": "添加水印",
    "extract-pdf": "提取页面和文本",
    "organize-pdf": "整理PDF",
    "add-page-numbers": "添加页码",
    "book-writing-toolbox": "图书制作工具",
    "magazine-maker": "杂志制作工具",
    "catalog-maker": "目录制作工具",
    "document-assembler": "文档组装工具",
    "redact-pdf": "PDF信息隐去",
    "ocr-pdf": "PDF文字识别",
    "html-to-pdf": "HTML转PDF",
    "fillable-forms": "可填写表单",
    "compare-pdf": "比较PDF",
    "repair-pdf": "修复PDF",
    "crop-pdf": "裁剪PDF",
    "pdf-editor": "PDF编辑器",
    "sign-pdf": "PDF签名",
    "compress-image": "压缩图片",
    "resize-crop": "调整大小和裁剪",
    "convert-image": "转换格式",
    "remove-background": "移除背景",
    "flip-rotate-image": "翻转和旋转",
    "image-filters": "添加滤镜和效果",
    "document-scanner": "文档扫描仪",
    "camera-capture": "相机拍摄",
    "bulk-image": "批量处理",
    "webp-converter": "WebP转换器",
    "passport-photo": "证件照制作",
    "screenshot-tool": "截图工具",
    "collage-maker": "照片拼贴制作",
    "compress-video": "压缩视频",
    "convert-video": "格式转换器",
    "trim-video": "剪辑",
    "merge-video": "合并视频",
    "video-to-gif": "视频转GIF",
    "thumbnail-gen": "缩略图生成器",
    "subtitle-adder": "添加字幕",
    "screen-recorder": "屏幕录制",
    "extract-audio": "提取音频",
    "audio-trimmer": "音频剪辑",
    "audio-converter": "音频转换器",
    "audio-merger": "合并音频",
    "audio-compressor": "音频压缩器",
    "voice-recorder": "录音机",
    "audio-speed-changer": "更改音频速度",
    "silence-remover": "移除静音",
    "audio-normalizer": "音量标准化",
    "audio-comparer": "比较两个音频文件",
    "noise-remover": "移除背景噪音",
    "audio-scrambler": "音频加扰器",
  },
  ko: {
    "merge-pdf": "PDF 병합",
    "split-pdf": "PDF 분할",
    "compress-pdf": "PDF 압축",
    "rotate-pdf": "PDF 회전",
    "pdf-to-word": "PDF를 Word로",
    "pdf-to-jpg": "PDF를 JPG로",
    "pdf-to-excel": "PDF를 Excel로",
    "word-to-pdf": "Word를 PDF로",
    "excel-to-pdf": "Excel을 PDF로",
    "powerpoint-to-pdf": "PowerPoint를 PDF로",
    "image-to-pdf": "이미지를 PDF로",
    "pdf-password": "PDF 비밀번호 추가",
    "pdf-watermark": "워터마크 추가",
    "extract-pdf": "페이지 및 텍스트 추출",
    "organize-pdf": "PDF 정리",
    "add-page-numbers": "페이지 번호 추가",
    "book-writing-toolbox": "도서 제작 도구",
    "magazine-maker": "잡지 제작 도구",
    "catalog-maker": "카탈로그 제작 도구",
    "document-assembler": "문서 조립 도구",
    "redact-pdf": "PDF 정보 삭제",
    "ocr-pdf": "PDF OCR",
    "html-to-pdf": "HTML을 PDF로",
    "fillable-forms": "작성 가능한 양식",
    "compare-pdf": "PDF 비교",
    "repair-pdf": "PDF 복구",
    "crop-pdf": "PDF 자르기",
    "pdf-editor": "PDF 편집기",
    "sign-pdf": "PDF 서명",
    "compress-image": "이미지 압축",
    "resize-crop": "크기 조정 및 자르기",
    "convert-image": "형식 변환",
    "remove-background": "배경 제거",
    "flip-rotate-image": "뒤집기 및 회전",
    "image-filters": "필터 및 효과 추가",
    "document-scanner": "문서 스캐너",
    "camera-capture": "카메라 촬영",
    "bulk-image": "일괄 처리",
    "webp-converter": "WebP 변환기",
    "passport-photo": "여권 사진 제작",
    "screenshot-tool": "스크린샷 도구",
    "collage-maker": "콜라주 제작",
    "compress-video": "동영상 압축",
    "convert-video": "형식 변환기",
    "trim-video": "트리밍 및 자르기",
    "merge-video": "동영상 병합",
    "video-to-gif": "동영상을 GIF로",
    "thumbnail-gen": "썸네일 생성기",
    "subtitle-adder": "자막 추가",
    "screen-recorder": "화면 녹화",
    "extract-audio": "오디오 추출",
    "audio-trimmer": "오디오 트리밍",
    "audio-converter": "오디오 변환기",
    "audio-merger": "오디오 병합",
    "audio-compressor": "오디오 압축기",
    "voice-recorder": "음성 녹음기",
    "audio-speed-changer": "오디오 속도 변경",
    "silence-remover": "무음 제거",
    "audio-normalizer": "볼륨 정규화",
    "audio-comparer": "두 오디오 파일 비교",
    "noise-remover": "배경 소음 제거",
    "audio-scrambler": "오디오 스크램블러",
  },
  id: {
    "merge-pdf": "Gabung PDF",
    "split-pdf": "Pisah PDF",
    "compress-pdf": "Kompres PDF",
    "rotate-pdf": "Putar PDF",
    "pdf-to-word": "PDF ke Word",
    "pdf-to-jpg": "PDF ke JPG",
    "pdf-to-excel": "PDF ke Excel",
    "word-to-pdf": "Word ke PDF",
    "excel-to-pdf": "Excel ke PDF",
    "powerpoint-to-pdf": "PowerPoint ke PDF",
    "image-to-pdf": "Gambar ke PDF",
    "pdf-password": "Tambah Kata Sandi PDF",
    "pdf-watermark": "Tambah Watermark",
    "extract-pdf": "Ekstrak Halaman dan Teks",
    "organize-pdf": "Atur PDF",
    "add-page-numbers": "Tambah Nomor Halaman",
    "book-writing-toolbox": "Pembuat Buku",
    "magazine-maker": "Pembuat Majalah",
    "catalog-maker": "Pembuat Katalog",
    "document-assembler": "Penyusun Dokumen",
    "redact-pdf": "Redaksi PDF",
    "ocr-pdf": "OCR PDF",
    "html-to-pdf": "HTML ke PDF",
    "fillable-forms": "Formulir yang Dapat Diisi",
    "compare-pdf": "Bandingkan PDF",
    "repair-pdf": "Perbaiki PDF",
    "crop-pdf": "Potong PDF",
    "pdf-editor": "Editor PDF",
    "sign-pdf": "Tanda Tangan PDF",
    "compress-image": "Kompres Gambar",
    "resize-crop": "Ubah Ukuran dan Potong",
    "convert-image": "Konversi Format",
    "remove-background": "Hapus Latar Belakang",
    "flip-rotate-image": "Balik dan Putar",
    "image-filters": "Tambah Filter dan Efek",
    "document-scanner": "Pemindai Dokumen",
    "camera-capture": "Tangkap Kamera",
    "bulk-image": "Pemroses Massal",
    "webp-converter": "Konverter WebP",
    "passport-photo": "Pembuat Foto Paspor",
    "screenshot-tool": "Alat Tangkapan Layar",
    "collage-maker": "Pembuat Kolase",
    "compress-video": "Kompres Video",
    "convert-video": "Konverter Format",
    "trim-video": "Potong dan Rapikan",
    "merge-video": "Gabung Video",
    "video-to-gif": "Video ke GIF",
    "thumbnail-gen": "Pembuat Thumbnail",
    "subtitle-adder": "Tambah Subtitle",
    "screen-recorder": "Perekam Layar",
    "extract-audio": "Ekstrak Audio",
    "audio-trimmer": "Pemotong Audio",
    "audio-converter": "Konverter Audio",
    "audio-merger": "Gabung Audio",
    "audio-compressor": "Kompresor Audio",
    "voice-recorder": "Perekam Suara",
    "audio-speed-changer": "Ubah Kecepatan Audio",
    "silence-remover": "Penghapus Keheningan",
    "audio-normalizer": "Penormal Volume",
    "audio-comparer": "Bandingkan Dua File Audio",
    "noise-remover": "Penghapus Kebisingan Latar",
    "audio-scrambler": "Pengacak Audio",
  },
};

export function getToolName(locale: Locale, toolId: string, englishName: string): string {
  return TOOL_NAME_TRANSLATIONS[locale]?.[toolId] ?? englishName;
}
